export const getDayDetailsByUnitAndStartDate = (anytimeMinNightsAndPricingDataAllUnits, unitId, startDate) => {
  const datesArray = anytimeMinNightsAndPricingDataAllUnits[unitId]
  return datesArray.find(
    (item, index) =>
      datesArray[index + 1] && startDate.isBetween(datesArray[index].date, datesArray[index + 1].date, undefined, "[)")
  )
}

export const getCampsiteNameForBookingUrl = (campsiteName) => {
  if (campsiteName === "orchardview") {
    return "orchardviewfarm"
  }
  return campsiteName
}
